export default [
  {
    text: "GeoHECRAS",
    description: "Rapidly construct 1D & 2D HEC-RAS models, producing better and more accurate results. Accelerate engineering workflows and streamline analysis review.",
    value: "9a7b965d-ec50-4fe8-9141-f98d6ea7e2e6",
    image: "/static/images/products/GeoHECRAS.ico",
    nameImage:"/static/images/products/GeoHECRAS_Registered.png",
    cardImage: "/static/images/products/GeoHECRAS-Card-Image.webp",
    downloadInfo: {
      sharefile: {
        publicDir: "fo71e46a-38a1-4060-af03-171dfbb11a9c",
        public: "fi1cd1df-0aa3-7eb6-973d-f2a1a00bef19",
        betaDir: "fo48da9d-b47b-4d72-9a6e-459c83d0c2e6",
        beta: "fi2b3188-b406-ea73-1009-ad399c85dcaa",
        drPublicDir: "fo1e1ac9-d388-4c57-8eba-c3aa2eacfe19",
        drBetaDir: "fo3504aa-9386-4556-8788-b4c8dada20a2"
      }
    },
    engines: {
      title: "HEC-RAS Engines",
      sharefileDir: "fo75c9b0-cb5b-4c21-b636-319e6deba9ef",
      downloadInfo: [
        {
          title: "",
          public: ""
        }
      ]
    },
    variants: [
      { text: "GeoHECRAS 1D", value: "9a7b965d-ec50-4fe8-9141-f98d6ea7e2e6" },
      { text: "GeoHECRAS 1D & 2D", value: "4e27ae81-6e93-4c1f-ac15-699be660cd0a" }
    ]
  },
  {
    text: "GeoHECHMS",
    description: "Greatly speed up the process for creating, analyzing, and reviewing stormwater models using the industry‑standard Army Corps of Engineers HEC‑HMS.",
    value: "55eebc12-0b34-47b4-b2c0-5207961ed2b0",
    image: "/static/images/products/GeoHECHMS.ico",
    nameImage:"/static/images/products/GeoHECHMS_Registered.png",
    cardImage: "/static/images/products/GeoHECHMS-Card-Image.webp",
    downloadInfo: {
      sharefile: {
        publicDir: "foc0aa33-a461-4c5e-bafb-087e296cb228",
        public: "fi1eee7a-4863-e962-1eb4-0451588ec46c",
        betaDir: "fo0c6f3f-c1c3-4e62-8d6b-d609f8f45d65",
        beta: "fi9e72cf-cd2d-04a5-07d7-27a1a1d3a780",
        drPublicDir: "fo63670b-838f-42c4-9432-b7748bf38b6a",
        drBetaDir: "fo7c6464-7123-43c2-af34-973fc8043852"
      }
    },
    variants: [
      { text: "GeoHECHMS", value: "55eebc12-0b34-47b4-b2c0-5207961ed2b0" }
    ]
  },
  {
    text: "GeoSTORM",
    description: "Accelerate the process of designing, analyzing, and reviewing urban and rural stormwater models in an AutoCAD compatible user interface.",
    value: "dca86248-c9c2-432e-a38e-1dc87b1cec16",
    image: "/static/images/products/GeoSTORM.ico",
    nameImage:"/static/images/products/GeoSTORM_Registered.png",
    cardImage: "/static/images/products/GeoSTORM-Card-Image.webp",
    downloadInfo: {
      sharefile: {
        publicDir: "foab1ce9-9f37-4a6a-a536-54f712663adb",
        public: "fi505a88-3aad-620c-ba53-14a6b6e5213e",
        betaDir: "fo339e4c-82e1-4758-902b-08371b587865",
        beta: "fi7fc906-7874-d4a8-83f5-0fa41ba444ff",
        drPublicDir: "foac1154-857f-44c4-8610-2a3a9e249852",
        drBetaDir: "fo3073df-1d5e-4f05-820b-9a3e5a29fa70"
      }
    },
    variants: [
      { text: "GeoSTORM Starter", value: "dca86248-c9c2-432e-a38e-1dc87b1cec16" },
      { text: "GeoSTORM Standard", value: "1329ab1a-012d-4bc7-892d-c40a66c35ba1" },
      { text: "GeoSTORM Professional", value: "1ace0b8c-4d58-47d7-91f1-82c893778216" }
    ]
  }
];
